export const H3_BASE_CSS_VARS = {
  "theme-website-h3-color-text": "var(--theme-website-color-text-primary)",
  "theme-website-h3-font-family": "InterVariable",
  "theme-website-h3-font-size": "2.375rem",
  "theme-website-h3-font-weight": "600",
  "theme-website-h3-line-height": "1.3",
  "theme-website-h3-letter-spacing": "0",
};
